import StatsSummary from './StatsSummary';

export default StatsSummary;
